import * as React from "react";
import {useEffect, useState} from "react";
import {Alert, FlatList, Platform, SafeAreaView, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import CapexDetailComponent from "../../components/capex/CapexDetailComponent";
import config from "../../utils/config";
import Axios from "axios";
import HandleHTTPError from "../../utils/handleErrors";
import AsyncStorage from "@react-native-async-storage/async-storage";
import numeral from "numeral";

export default function RequestDetailScreen({route, navigation}) {
    const capex = route.params.item;
    const approvals = capex.approvals;
    const [working, setWorking] = useState(false);
    const [currentUser, setCurrentUser] = useState(null)


    useEffect(() => {
        AsyncStorage.getItem('appData')
            .then(result => {
                if (result) {
                    console.log(result)
                    setCurrentUser(JSON.parse(result));
                }
            })
    }, []);

    const changeRequestStatus = (status) => {
        if (!currentUser) {
            if (Platform.OS === "web") {
                alert("Error, No user");
            } else {
                Alert.alert("Error, No user");
            }
            return;
        }
        console.log(capex)
        setWorking(true);
        const msg = "La solicitud fue cancelada";
        const uri = `${config.api.host}requisitions/capex/cancel/${capex.id}`;

        const body = {status, canceled_by: currentUser.profile_id};
        Axios.patch(uri, body, {
            headers: config.api.headers,
        })
            .then(() => {
                setWorking(false);
                if (Platform.OS === "web") {
                    alert("Se cambió el estado de la solicitud", msg);
                } else {
                    Alert.alert("Se cambió el estado de la solicitud", msg);
                }

                navigation.navigate("RequestListScreen");
            })
            .catch((error) => {
                if (Platform.OS === "web") {
                    alert(`Ha ocurrido un error ${JSON.stringify(error.response)}`);
                } else {
                    HandleHTTPError(error, navigation);
                }
                setWorking(false);
            });
    };

    const renderStatus = (status) => {
        if (status === 0) {
            return <Text style={{color: "#007bff"}}>En proceso</Text>;
        }
        if (status === 1) {
            return <Text style={{color: "#28a745"}}>Aprobada</Text>;
        }
        if (status === 2) {
            return <Text style={{color: "#dc3545"}}>Rechazada</Text>;
        }
        if (status === 3) {
            return <Text style={{color: "#dc3545"}}>Cancelada</Text>;
        }
    };

    const renderKind = (kind) => {
        if (kind === "capex") {
            return <Text style={{color: "#007bff"}}>CAPEX</Text>;
        }
        if (kind === "sub") {
            return <Text style={{color: "#6c757d"}}>Subdivisión</Text>;
        }
        if (kind === "change") {
            return <Text style={{color: "#28a745"}}>Cambio</Text>;
        }
        return <Text style={{color: "#dc3545"}}>AUTO</Text>;
    };
    const renderNames = (element) => {
        if (element.kind === "change") {
            return (
                <>
                    <Text>
                        Emisor: {element.name} {renderKind(element.kind)}
                    </Text>
                    <Text>Receptor: {element.capex_receiver.name}</Text>
                </>
            );
        } else {
            return (
                <Text>
                    {element.name} {renderKind(element.kind)}
                </Text>
            );
        }
    };

    const RenderRequestRow = ({element}) => {
        const RowContent = (
            <View style={styles.rowContainer}>
                <View style={{flex: 1}}>
                    {renderNames(element)}
                    <Text>Solicitante: {element.requested_by?.full_name}</Text>
                    <Text>Descripción: {element.description}</Text>
                    <Text>
                        Monto solicitado:
                        <Text style={{fontWeight: "bold", color: "green"}}>
                            {numeral(element.budget_requested).format("000,000.00")}
                        </Text>
                    </Text>
                </View>
                <View style={{flex: 1}}>
                    {renderStatus(element.status)}
                    {renderLastAprove(element)}
                    {element.reviewer && (
                        <Text>Aprobador pendiente: {element.reviewer?.full_name}</Text>
                    )}
                    {(element.status !== 2 && element.status !== 3) && (
                        <View style={{marginVertical: 10}}>
                            <Text
                                onPress={() => {
                                    if (working) {
                                        return;
                                    }
                                    const confirm = () => changeRequestStatus(3);
                                    if (Platform.OS === "web") {
                                        if (window.confirm("¿Estás seguro de cancelar esta solicitud?")) {
                                            confirm();
                                        }
                                    } else {
                                        Alert.alert(
                                            "Confirmar cancelación",
                                            "¿Estás seguro de cancelar esta solicitud?",
                                            [
                                                {text: "No", style: "cancel"},
                                                {text: "Sí", onPress: confirm},
                                            ]
                                        );
                                    }
                                }}
                                style={{
                                    backgroundColor: working ? "#bcbbbb": "#dc3545",
                                    color: "#fff",
                                    paddingVertical: 10,
                                    textAlign: "center",
                                    borderRadius: 6,
                                    fontWeight: "bold",
                                }}
                            >
                                Cancelar solicitud
                            </Text>
                        </View>
                    )}
                </View>
            </View>
        );

        if (Platform.OS === "web") {
            return RowContent;
        }

        return (
            <TouchableOpacity
                onPress={() => {
                    navigation.navigate(route, {
                        item: element,
                    });
                }}
            >
                {RowContent}
            </TouchableOpacity>
        );
    };

    const renderLastAprove = (element) => {
        if (element.canceled_by) {
            return (
                <Text>
                    Cancelada por: {element.canceled_by?.code} {element.canceled_by?.full_name}
                </Text>
            );
        } else if (element.rejected_by) {
            return (
                <Text>
                    No aprobada por: {element.approved_by?.code} {element.rejected_by?.full_name}
                </Text>
            );
        } else if (element.approved_by) {
            return (
                <Text>
                    Aprobada por: {element.approved_by?.code} {element.approved_by?.full_name}
                </Text>
            );
        }
        return <Text>Sin información para mostrar</Text>;
    };


    const renderItem = ({item}) => {
        return (
            <View style={styles.cardItem}>
                <View style={styles.body}>
                    {renderLastAprove(item)}
                </View>
                <View style={styles.right}>
                    <Text>Fecha: {new Date(item.created_at).toLocaleString()}</Text>
                </View>
            </View>
        );
    };

    return (
        <SafeAreaView style={styles.container}>
            <View style={styles.content}>
                <CapexDetailComponent capex={capex.capex}/>
                <RenderRequestRow element={capex}/>

                <View style={styles.card}>
                    <Text style={styles.title}>Histórico de aprobaciones</Text>
                    <FlatList
                        data={approvals}
                        renderItem={renderItem}
                        keyExtractor={(item, index) => index.toString()}
                    />
                </View>
            </View>
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    content: {
        flex: 1,
        padding: 10,
        ...(Platform.OS === "web" && {
            width: "50%",
            alignSelf: "center",
        }),
    },
    card: {
        backgroundColor: "#fff",
        borderRadius: 8,
        padding: 10,
        shadowColor: "#000",
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
    },
    title: {
        fontWeight: "bold",
        fontSize: 16,
        marginBottom: 10,
    },
    cardItem: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 8,
        borderBottomWidth: 1,
        borderColor: "#eee",
    },
    body: {
        flex: 1,
    },
    right: {
        justifyContent: "center",
        marginLeft: 10,
    },
    rowContainer: {
        paddingVertical: 10,
        borderBottomWidth: 1,
        flexDirection: 'row',
        backgroundColor: '#ffffff',
        marginVertical: 8,
        padding: 14,
        borderRadius: 10,
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.05,
        shadowRadius: 4,
        elevation: 2,
        borderColor: '#bcbbbb',
        borderWidth: 1
    },
});
